module.exports = __webpack_public_path__ + "static/img/image_solutions_accss_02.1698ddc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource/images/solution/image_solutions_accss_02.png
// module id = dMTg
// module chunks = 10